import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Button, Table, message } from 'antd';
import { Link } from 'react-router-dom';
import { DownloadOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { getErrorMessages } from 'app/utils/functions';
import {
  exportTsaTrialRegistrations,
  getTsaTrialRegistrations,
} from '../service';
import { buildRegistrationTableColumns } from '../registrationTableUtils';

class AdminTsaTrialRegistrationList extends Component {
  state = {
    loading: false,
    exportLoading: false,
    period: null,
    fields: [],
    items: [],
    pagination: {
      current: 1,
      pageSize: 20,
      total: 0,
    },
  };

  componentDidMount() {
    this.load(1);
  }

  getPeriodId = () => {
    const id = this.props.match?.params?.periodId;
    return id ? parseInt(id, 10) : 0;
  };

  load = async (page = 1) => {
    const periodId = this.getPeriodId();
    if (!periodId) {
      return;
    }

    this.setState({ loading: true });
    const { pagination } = this.state;
    const response = await getTsaTrialRegistrations(periodId, page, pagination.pageSize);

    if (response.data.code === 200) {
      const data = response.data.data;
      this.setState({
        period: data.period,
        fields: data.fields || [],
        items: data.items || [],
        pagination: {
          ...pagination,
          current: data.page,
          total: data.total_count,
        },
      });
    } else {
      message.error(getErrorMessages(response.data));
    }
    this.setState({ loading: false });
  };

  handleTableChange = (pager) => {
    this.load(pager.current);
  };

  exportCsv = async () => {
    const periodId = this.getPeriodId();
    if (!periodId) {
      return;
    }

    this.setState({ exportLoading: true });
    try {
      const response = await exportTsaTrialRegistrations(periodId);
      const blob = new Blob([response.data], {
        type: 'text/csv;charset=utf-8',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const slug = this.state.period?.code || periodId;
      link.download = `dang-ky-thi-trai-nghiem-${slug}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      message.success('Đã tải file CSV');
    } catch (e) {
      message.error('Không xuất được file CSV');
    }
    this.setState({ exportLoading: false });
  };

  render() {
    const { loading, exportLoading, period, fields, items, pagination } = this.state;
    const columns = buildRegistrationTableColumns(fields);

    return (
      <Container className="page-exam">
        <Row>
          <Col xs={12}>
            <div className="flex space-between align-center mb-4">
              <div>
                <Link to="/admin/tsa-trial-periods">
                  <Button type="link" icon={<ArrowLeftOutlined />} className="pl-0">
                    Quay lại danh sách đợt
                  </Button>
                </Link>
                <h3 className="mb-0">
                  Danh sách đăng ký
                  {period?.title ? `: ${period.title}` : ''}
                </h3>
              </div>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                loading={exportLoading}
                onClick={this.exportCsv}
              >
                Xuất CSV
              </Button>
            </div>
            <Table
              rowKey="id"
              loading={loading}
              columns={columns}
              dataSource={items}
              scroll={{ x: Math.max(900, columns.length * 140) }}
              pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: pagination.total,
                showSizeChanger: false,
              }}
              onChange={this.handleTableChange}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default AdminTsaTrialRegistrationList;
